import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AmountPipe } from './amount.pipe';
import { AvatarPipe } from './avatar.pipe';
import { DateTimePipe } from './date-time.pipe';

@NgModule({
  declarations: [DateTimePipe, AmountPipe, AvatarPipe],
  imports: [CommonModule],
  exports: [DateTimePipe, AmountPipe, AvatarPipe],
})
export class PipesModule {}
